var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"align-items-center d-flex flex-column p-12 p-base-medium text-neutral-400"},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }